// extracted by mini-css-extract-plugin
export default {"Navigation":"Navigation_Navigation__CD292","Sidedraw":"Navigation_Sidedraw__Unxeg"};